import { Receipt } from "@/types/receipt";
import { translate, formatDate } from "@/utils/formatters";

import styles from "./GoodbyeSection.module.css";

interface GoodbyeSectionProps {
  receipt: Receipt;
  lang: string;
}

export const GoodbyeSection = ({ receipt, lang }: GoodbyeSectionProps) => {
  const tableNumbers = receipt.extra_receipt_view?.table_numbers ?? [];
  const waiterName = receipt.extra_receipt_view?.waiter_name;

  if (
    !(
      receipt.extra_receipt_view?.cashier_goodbye_message ||
      receipt.extra_receipt_view?.opening_hours ||
      receipt.extra_receipt_view?.return_policy ||
      receipt.extra_receipt_view?.customer_buyers ||
      receipt.extra_receipt_view?.company_buyers ||
      receipt.extra_receipt_view?.seller_id ||
      receipt.extra_receipt_view?.seller_name ||
      receipt.extra_receipt_view?.operator_id ||
      receipt.extra_receipt_view?.operator_name ||
      receipt.extra_receipt_view?.operator_text ||
      tableNumbers.length > 0 ||
      waiterName
    )
  ) {
    return null;
  }

  return (
    <div className="box white">
      {receipt.extra_receipt_view?.customer_buyers &&
        receipt.extra_receipt_view?.customer_buyers.length > 0 && (
          <div className={styles.sectionBlock}>
            <h5>{translate(lang, "Kunde:", "Customer:")}</h5>
            {receipt.extra_receipt_view?.customer_buyers.map(
              (customer, index) => (
                <div key={"customer-" + index}>
                  <h5>
                    {customer.name} {customer.surname}
                  </h5>
                  <h5>{customer.phone_number}</h5>
                </div>
              )
            )}
          </div>
        )}

      {receipt.extra_receipt_view?.company_buyers &&
        receipt.extra_receipt_view?.company_buyers.length > 0 && (
          <div className={styles.sectionBlock}>
            <h5>{translate(lang, "Bedriftskunde:", "Company customer:")}</h5>
            {receipt.extra_receipt_view?.company_buyers.map(
              (company, index) => (
                <div key={"company-" + index}>
                  <h5>
                    {company.name} {company.suffix}
                  </h5>
                  <h5>{company.common_name}</h5>
                  <h5>
                    {company.org_number} {company.country_code}
                  </h5>
                </div>
              )
            )}
          </div>
        )}

      {(tableNumbers.length > 0 || waiterName) && (
        <div className={styles.sectionBlock}>
          <h5>{translate(lang, "Servering:", "Service:")}</h5>
          {tableNumbers.length > 0 && (
            <h5>
              {translate(lang, "Bordnummer:", "Table number:")}{" "}
              {tableNumbers.join(", ")}
            </h5>
          )}
          {waiterName && (
            <h5>
              {translate(lang, "Servitør:", "Waiter:")} {waiterName}
            </h5>
          )}
        </div>
      )}

      {(receipt.extra_receipt_view?.seller_id ||
        receipt.extra_receipt_view?.seller_name ||
        receipt.extra_receipt_view?.operator_id ||
        receipt.extra_receipt_view?.operator_name ||
        receipt.extra_receipt_view?.operator_text) && (
        <div className={styles.sectionBlock}>
          <h5>{translate(lang, "Selger: ", "Seller: ")}</h5>
          {receipt.extra_receipt_view?.seller_id && (
            <h5>
              {translate(lang, "Selger-ID: ", "Seller-ID: ")}
              {receipt.extra_receipt_view?.seller_id}
            </h5>
          )}
          {receipt.extra_receipt_view?.seller_name && (
            <h5>
              {translate(lang, "Selger: ", "Seller: ")}
              {receipt.extra_receipt_view?.seller_name}
            </h5>
          )}
          {receipt.extra_receipt_view?.operator_id && (
            <h5>
              {translate(lang, "Operatør-ID: ", "Operator-ID: ")}
              {receipt.extra_receipt_view?.operator_id}
            </h5>
          )}
          {receipt.extra_receipt_view?.operator_name && (
            <h5>
              {translate(lang, "Operatør: ", "Operator: ")}
              {receipt.extra_receipt_view?.operator_name}
            </h5>
          )}
          {receipt.extra_receipt_view?.operator_text && (
            <h5>
              {translate(lang, "Operatørtekst: ", "Operator text: ")}
              {receipt.extra_receipt_view?.operator_text}
            </h5>
          )}
        </div>
      )}

      {receipt.extra_receipt_view?.opening_hours && (
        <h5 className={styles.sectionBlock}>
          {translate(lang, "Åpningstider: ", "Opening hours: ")}
          <br />
          {receipt.extra_receipt_view?.opening_hours}
        </h5>
      )}
      {receipt.extra_receipt_view?.return_policy && (
        <h5 className={styles.sectionBlock}>
          {translate(lang, "Åpent Kjøp: ", "Return policy: ")}
          <br />
          {receipt.extra_receipt_view?.return_policy.description}
          <br />
          {receipt.extra_receipt_view?.return_policy.expired_at &&
            translate(lang, "Utløper: ", "Expires: ") +
              formatDate(
                receipt.extra_receipt_view.return_policy.expired_at,
                receipt.merchant.country_code,
                false
              )}
        </h5>
      )}
      {receipt.extra_receipt_view?.cashier_goodbye_message && (
        <h5 className={styles.sectionBlock}>
          {receipt.extra_receipt_view?.cashier_goodbye_message}
        </h5>
      )}
    </div>
  );
};
